import { Inject, Injectable } from '@angular/core';
import { AvailabilityService } from '@x/ecommerce-shop/app/core/availability/availability.service';
import { IVariantAvailability } from '@x/ecommerce-shop/app/core/product/types/variant-availability';
import { IShopConfig, SHOP_CONFIG } from '@x/ecommerce-shop/config/shop.config';
import { IShopOrder, IShopProductItem, IShopProductVariant } from '@x/ecommerce/shop-client';

@Injectable()
export class ProductVariantAvailabilityService {
  getVariantAvailability(
    variant: IShopProductVariant,
    order: IShopOrder | null,
  ): IVariantAvailability {
    const bagQuantity = order?.items?.find((item) => item.variantId === variant.id)?.quantity || 0;

    const {
      isAvailable,
      region,
      minAvailableDate,
      maxAvailableDate,
      maxAvailableQuantity,
      unavailableReason,
    } = variant.availability;

    return {
      variant_id: variant.id,
      availableRegions: variant.availableRegions,
      showDeliveryRegionBadges: this.shopConfig.features.availability.showDeliveryRegionBadges,
      bagQuantity,
      price: variant.price,
      minAvailableDate,
      maxAvailableDate,
      maxAvailableQuantity,
      availabilityView: this.availabilityService.getAvailabilityView({
        isAvailable,
        minAvailableDate,
        maxAvailableDate,
        maxAvailableQuantity,
        unavailableReason,
        availabilityRegionId: region?.id,
        availableRegionsCount: variant.availableRegions.length,
      }),
    };
  }

  getProductVariantAvailability(
    product: IShopProductItem,
    order: IShopOrder | null,
  ): IVariantAvailability {
    const { variants, variation } = product;

    let _variant = variants[0];

    if (variation === 'OPTION') {
      const sortByCheapest = [...variants].sort((a, b) => a.price.amount - b.price.amount);

      const firstAvailableVariant = sortByCheapest.find((v) => v.availability.isAvailable);

      _variant = firstAvailableVariant ? firstAvailableVariant : sortByCheapest[0];
    }

    return this.getVariantAvailability(_variant, order);
  }

  constructor(
    @Inject(SHOP_CONFIG) private shopConfig: IShopConfig,
    private availabilityService: AvailabilityService,
  ) {}
}
